// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const toxel: PokeData = {
  "id": 848,
  "name": "toxel",
  "height": 4,
  "weight": 110,
  "base_experience": 48,
  "types": [
    PokeType.ELECTRIC,
    PokeType.POISON
  ],
  "api_moves": [
    "growl",
    "acid",
    "flail",
    "belch",
    "nuzzle",
    "tearful-look"
  ],
  "moves": [
    "growl",
    "acid",
    "acid-rain",
    "poison-jab",
    "sludge-bomb",
    "wild-charge",
    "mortal-gas",
    "volt-switch",
    "volt-crash",
    "thunder-fang",
    "stun-spore",
    "quick-tempo",
    "toxic-overload"
  ],
  "evolution_chain": {
    "id": 446,
    "item": null,
    "species": [
      {
        "name": "toxel",
        "order": 848,
        "types": [
          PokeType.ELECTRIC,
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "toxtricity",
        "order": 849,
        "types": [
          PokeType.ELECTRIC,
          PokeType.POISON
        ],
        "evolves_from_species_id": 848,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 37.5,
    "speed": 40,
    "ability_power": 54
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
